import React from 'react'
import { completeLogin } from '../utils/complete-login'
import { BackupCodesPanel } from './BackupCodesPanel'
import { FirstTimeStepBadge } from './FirstTimeStepBadge'
import { OtpForm } from './OtpForm'
import { VerifyAppBackLink } from './VerifyAppBackLink'

/**
 * Drives the authenticator-app screen across its two first-time-setup steps:
 *  - Step 3: enter the 6-digit TOTP code ({@link OtpForm}).
 *  - Step 4: save the one-time backup codes ({@link BackupCodesPanel}), shown
 *    once {@link OtpForm} confirms MFA setup and hands the codes up.
 */
export function VerifyAppFlow() {
  const [backupCodes, setBackupCodes] = React.useState<Array<string> | null>(null)

  if (backupCodes) {
    return (
      <>
        {/* Step Badge (visible during first-time login setup) */}
        <FirstTimeStepBadge step={4} />
        <BackupCodesPanel codes={backupCodes} onContinue={() => void completeLogin()} />
      </>
    )
  }

  return (
    <>
      {/* 1. Step Badge (visible during first-time login setup) */}
      <FirstTimeStepBadge step={3} />

      {/* 2. Page Header Info (SEO Heading Hierarchy) */}
      <header className="flex flex-col gap-2">
        <h1 className="text-xl font-bold tracking-tight text-brand-dark-text">
          Enter verification code
        </h1>
        <p className="text-sm text-brand-copyright leading-relaxed">
          Enter the 6-digit code from your authenticator app
        </p>
      </header>

      {/* 3. 6-Digit OTP Box Grid (authenticator-app TOTP) */}
      <OtpForm mode="app" onMfaSetupComplete={setBackupCodes} />

      <hr className="border-brand-border-light" />

      {/* 4. Back Action (destination depends on first-time vs. returning) */}
      <VerifyAppBackLink />
    </>
  )
}
